import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f005b1fa&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f005b1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f005b1fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f005b1fa')) {
      api.createRecord('f005b1fa', component.options)
    } else {
      api.reload('f005b1fa', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f005b1fa&scoped=true&", function () {
      api.rerender('f005b1fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PgC415szXlrN/JS/comp/DocBox.vue"
export default component.exports